import React, { useState } from "react";
import { Submitbtn } from "../../../Component";
import { InputField } from "../../../Component";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { addTagOption } from "../adminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { validateAgeGrp } from "../../../Utils/validators";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";

const AddTagOption = () => {
  const initialVal = [
    {
      name: "",
      order: "",
    },
  ];
  const dispatch: Function = useDispatch<AppDispatch>();
  const [tagArr, setTagArr] = useState<any>(initialVal);
  const onchangeTagOption = (value: any, index: any, key: any) => {
    let newArr = JSON.parse(JSON.stringify(tagArr));
    if (key === "order") {
      if (validateAgeGrp(value)) {
        newArr[index][key] = value;
        setTagArr(newArr);
      }
    } else if (key === "name") {
      newArr[index][key] = value;
      setTagArr(newArr);
    }
  };
  const onPressAdd = () => {
    setTagArr([...tagArr, initialVal[0]]);
  };
  const handleClose = (index: any) => {
    const newArray = [...tagArr];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setTagArr(newArray);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      book: tagArr,
    };
    dispatch(
      addTagOption({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setTagArr(initialVal);
            dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const validations = () => {
    let isValid = false;
    tagArr?.map((item: any) => {
      if (item.name === "" || item.order === "") {
        isValid = true;
      }
    });
    return isValid;
  };

  const renderForm = () => {
    return (
      <form onSubmit={handleSubmit}>
        {tagArr?.map((item: any, index: any) => {
          const { name, order } = item;
          return (
            <div className="row bxshadow p-2 borderRadius mb-4 w-75">
              <div className="col-md-6 mb-3">
                <LabelInput labelName={`Tag Option ${index + 1}`} isRequired />
                <InputField
                  key={"ex2"}
                  placeholder={"Enter Tag Option"}
                  setInputText={(value: any) =>
                    onchangeTagOption(value, index, "name")
                  }
                  value={name}
                />
              </div>
              <div className="col-md-6 mb-3">
                <LabelInput labelName={"Order number"} isRequired />
                <InputField
                  key={"ex2"}
                  placeholder={`Order  No. ${index + 1}`}
                  setInputText={(value: any) =>
                    onchangeTagOption(value, index, "order")
                  }
                  value={order}
                  maxLength={3}
                />
              </div>
              {index === tagArr.length - 1 && (
                <div className="col-md-2 ms-auto text-end">
                  <AddMoreBtn handleClick={onPressAdd} />
                </div>
              )}
              {tagArr?.length === 1 ? ("") : (
                <DeleteForeverIcon
                  className="text-danger   mt-3"
                  onClick={() => handleClose(index)}
                />
              )}
            </div>
          );
        })}
        <div className="col-md-9">
          <div className="col-md-2 mx-auto my-4">
            <Submitbtn name={"Submit"} disabled={validations()} />
          </div>
        </div>
      </form >

    );
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Tag Option"} />
      </div>
      <div className="formDiv">
        <div className="">{renderForm()}</div>
      </div>
    </div>
  );
};

export default AddTagOption;
